import {
  determineAppEnvironment,
  determineConfigEnvironment,
} from '@optools/services/config/utils';
import { subWeeks } from 'date-fns/subWeeks';

export function generateDatadogLink(
  baseurl: string,
  userId: string,
  staticParams: Record<string, string>,
) {
  const url = new URL(baseurl);

  const env = determineConfigEnvironment(determineAppEnvironment());
  url.searchParams.set('query', `env:${env} *:"${userId}"`);
  url.searchParams.set('from_ts', subWeeks(new Date(), 1).getTime().toString());
  url.searchParams.set('to_ts', new Date().getTime().toString());

  Object.entries(staticParams).forEach(([key, value]) => {
    url.searchParams.set(key, value);
  });

  return url.toString();
}
